module.exports = __webpack_public_path__ + "static/img/expeditionPageImg.74b1c58.png";